import { memo } from 'react'
import { isEqual } from 'lodash'
import { PageTitle } from 'app/components/common/PageTitle'
import R from 'app/assets/R'
import { useTranslation } from 'react-i18next'
import Report004Container from 'app/containers/Report/Report004'

const Report004PageCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.report_004_doctor)}</PageTitle>
      <Report004Container />
    </>
  )
}
const Report004Page = memo(Report004PageCpn, isEqual)

export default Report004Page
